import {GenCountyCoverageData} from '../../../generated/serverModels/GenCountyCoverageData';

export class CountyCoverageData extends GenCountyCoverageData {
    constructor(county: CountyCoverageData) {
        super(county);
    }
}
